export function lisbonInput(value:Date=new Date()){
 const parts=new Intl.DateTimeFormat('sv-SE',{timeZone:'Europe/Lisbon',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(value);
 return parts.replace(' ','T');
}
export function lisbonISO(value:string){
 if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value))throw Error('Indique uma data e hora válidas.');
 const base=Date.parse(value+'Z'),matches:string[]=[];
 for(let offset=-12;offset<=14;offset++){
  const candidate=new Date(base-offset*3600000);
  if(Number.isFinite(candidate.getTime())&&lisbonInput(candidate)===value)matches.push(candidate.toISOString());
 }
 if(matches.length!==1)throw Error(matches.length?'Esta hora repete-se na mudança de hora. Escolha uma hora fora da transição.':'Esta data/hora não existe em Lisboa. Verifique os campos.');
 return matches[0];
}
